<template>
  <div>
    <Nav></Nav>
    <banner-part :bannerInfo="nowBannerInfo"></banner-part>
    <primary-tabs
      :tabsList="primaryTabs"
      :activeValue="navTabIndex"
      @tab-change="handleChangeNavTab"
    >
      <tabs-section
        :key="navTabIndex"
        :tabsList="tabsList"
        :defaultIndex="defaultIndex"
        @changeTabValueAction="handleChangeTabValue"
      ></tabs-section>
    </primary-tabs>

    <div class="container">
      <!-- 充电运营 -->
      <!-- 居民小区充电网 -->
      <cdyy-jmcdw v-if="navTabIndex == '1' && defaultIndex == '1'"></cdyy-jmcdw>
      <!-- 公共充电网 -->
      <cdyy-ggcdw v-if="navTabIndex == '1' && defaultIndex == '2'"></cdyy-ggcdw>
      <!-- 公路充电网 -->
      <cdyy-glcdw v-if="navTabIndex == '1' && defaultIndex == '3'"></cdyy-glcdw>
      <!-- 重卡换电 -->
      <cdyy-zkhd v-if="navTabIndex == '1' && defaultIndex == '4'"></cdyy-zkhd>
      <!-- 光储充车棚 -->
      <cdyy-gccc v-if="navTabIndex == '1' && defaultIndex == '5'"></cdyy-gccc>

      <!-- 能源聚合 -->
      <!-- 智慧微网（保留原页面内容） -->
      <cdyy-dyzhww v-if="navTabIndex == '2' && defaultIndex == '1'"></cdyy-dyzhww>
      <!-- 虚拟电厂（内容后续补充） -->
      <nyjh-xndc v-if="navTabIndex == '2' && defaultIndex == '2'"></nyjh-xndc>
      <!-- 电力交易 -->
      <nyjh-dljy v-if="navTabIndex == '2' && defaultIndex == '3'"></nyjh-dljy>

      <!-- 交能融合 -->
      <sjyy-jnrh v-if="navTabIndex == '3' && defaultIndex == '1'"></sjyy-jnrh>
      <!-- 车网互动（页面内容保持不变） -->
      <sjyy-cwhd v-if="navTabIndex == '3' && defaultIndex == '2'"></sjyy-cwhd>

    </div>
    <Footer class="top" />
  </div>
</template>

<script>
import BannerPart from "../components/BannerPart.vue";
import CdyyDyzhww from './cpns/cdyyDyzhww.vue';
import CdyyGgcdw from './cpns/cdyyGgcdw.vue';
import CdyyGlcdw from './cpns/cdyyGlcdw.vue';
import CdyyJmcdw from './cpns/cdyyJmcdw.vue';
import CdyyGccc from './cpns/cdyyGccc.vue';
import CdyyZkhd from './cpns/cdyyZkhd.vue';
import NyjhDljy from './cpns/nyjhDljy.vue';
import NyjhXndc from './cpns/nyjhXndc.vue';
import PrimaryTabs from '../components/primaryTabs.vue';
import SjyyCwhd from './cpns/sjyyCwhd.vue';
import SjyyJnrh from './cpns/sjyyJnrh.vue';
import TabsSection from './cpns/zhTabsSection.vue';
export default {
  components: { BannerPart, TabsSection, PrimaryTabs, CdyyDyzhww, CdyyGgcdw, CdyyGlcdw, CdyyJmcdw, CdyyGccc, CdyyZkhd, NyjhDljy, NyjhXndc, SjyyCwhd, SjyyJnrh },
  data() {
    return {
      bannerInfo: {
        text1: "智慧运营",
        text2: "智慧运营",
      },
      primaryTabs: [
        {
          value: "1",
          label: "充电运营",
          subtitle: "全场景充电运营管理",
          icon: "charging",
        },
        {
          value: "2",
          label: "能源聚合",
          subtitle: "汇聚分布式能源价值",
          icon: "aggregate",
        },
        {
          value: "3",
          label: "交能融合",
          subtitle: "能源交通协同发展",
          icon: "transport-energy",
        },
      ],
      tabsListInfo:{
        '1':[
          {
            value: "1",
            label: "居民小区充电网",
            subtitle: "安全便捷 · 智能管理 · 降本增效",
            icon: "community",
          },
          {
            value: "2",
            label: "公共充电网",
            subtitle: "广覆盖 · 高可用 · 优体验",
            icon: "public",
          },
          {
            value: "3",
            label: "公路充电网",
            subtitle: "高功率 · 快补能 · 强支撑",
            icon: "highway",
          },
          {
            value: "4",
            label: "重卡换电",
            subtitle: "分钟级换电 · 绿色高效运输",
            icon: "truck-swap",
          },
          {
            value: "5",
            label: "光储充车棚",
            subtitle: "绿色供能 · 高效补能 · 场景融合",
            icon: "solar-carport",
          },
        ],
        '2':[
          {
            value: "1",
            label: "智慧微网",
            subtitle: "多源协同 · 高效互补 · 智慧自治",
            icon: "multi-grid",
          },
          {
            value: "2",
            label: "虚拟电厂",
            subtitle: "资源聚合 · 协同调度",
            icon: "virtual-plant",
          },
          {
            value: "3",
            label: "电力交易",
            subtitle: "市场参与 · 智能协同",
            icon: "power-trade",
          },
        ],
        '3':[
          {
            value: "1",
            label: "交能融合",
            subtitle: "能源交通协同 · 绿色高效",
            icon: "transport-energy",
          },
          {
            value: "2",
            label: "车网互动",
            subtitle: "车桩网协同 · 双向互动",
            icon: "vehicle-grid",
          },
        ]
      },
      defaultIndex:'1',
    
      bannerInfoMap:{
        '1-1':{
          text1: "居民小区充电网",
          text2: "充电解决方案",
          swiperImg: require("./images/cdyy/jmcd-banner-pic.png")
        },

        '1-2':{
          text1: "公共充电网",
          text2: "充电解决方案",
          swiperImg: require("./images/cdyy/ggcdw-banner-pic.png")
        },

        '1-3':{
          text1: "公路充电网",
          text2: "充电解决方案",
          swiperImg: require("./images/cdyy/glcdw-banner-pic.png")
        },

        '1-4':{
          text1: "重卡换电解决方案",
          text2: "3–5分钟极速补能，助力货运物流绿色高效转型",
          swiperImg: require("./images/zkhd/zkhd-banner.jpg")
        },

        '1-5':{
          text1: "光储充车棚解决方案",
          text2: "绿色供能 · 高效补能 · 场景融合",
          swiperImg: require("./images/gccc/gccc-banner.jpg"),
          darkLeft: true
        },

        '2-1':{
          text1: "智慧微网",
          text2: "多源协同 · 高效互补 · 智慧自治",
          swiperImg: require("./images/cdyy/dyzhww-banner-pic.png")
        },
        '2-2':{
          text1: "虚拟电厂解决方案",
          text2: "聚合分布式资源，智慧协同调度，参与电力市场",
          swiperImg: require("./images/xndc/xndc-banner.jpg"),
          darkLeft: true
        },
        '2-3':{
          text1: "电力交易解决方案",
          text2: "绿色电力交易，市场参与，智能协同创价值",
          swiperImg: require("./images/dljy/dljy-banner.jpg"),
          darkLeft: true
        },

        '3-1':{
          text1: "交能融合解决方案",
          text2: "能源与交通协同发展，打造绿色高效新场景",
          swiperImg: require("./images/jnrh/jnrh-banner.jpg"),
          darkLeft: true
        },

        '3-2':{
          text1: "车网互动",
          text2: "做国内一流的智慧能源解决方案及服务提供商",
          swiperImg: require("./images/cdyy/sjyy-cwhd-banner-pic.png")
        },
      }
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.syncDefaultIndex();
      },
    },
  },

  computed:{
    tabsList(){
      return this.tabsListInfo[this.navTabIndex] || this.tabsListInfo['1']
    },
    navTabIndex(){
      const index = this.$route.params.index || '1'
      return ['1', '2', '3'].includes(index) ? index : '1'
    },
    nowBannerInfo(){
      return this.bannerInfoMap[this.navTabIndex + '-' + this.defaultIndex]
        || this.bannerInfoMap[this.navTabIndex + '-1']
    }
  },

  methods:{
    syncDefaultIndex(){
      const requestedIndex = this.$route.query.defaultIndex || '1'
      const validIndexes = (this.tabsListInfo[this.navTabIndex] || []).map(item => item.value)
      this.defaultIndex = validIndexes.includes(requestedIndex) ? requestedIndex : '1'
    },
    handleChangeNavTab(item){
      if(this.navTabIndex != item.value){
        this.$router.push({
          path: `/zhyw/${item.value}`,
          query: { defaultIndex: '1' }
        })
      }
    },
    handleChangeTabValue(value){
      this.defaultIndex = value
      if(this.$route.query.defaultIndex != value){
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, defaultIndex: value }
        })
      }
    }
  }

};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 600px;
}

</style>
